module.exports = __webpack_public_path__ + "img/ic_logout.3aeea2e4.svg";